

import actions from './moduleLocationActions.js'

export default {
  namespaced: true,
  actions
}
